import { useQuery } from '@tanstack/react-query'
import { apiService } from '../../services'

export const useAuth = (opts = {}) => {
  const {
    enabled = false,               // default: cache-only
    refetchOnWindowFocus = false,  // quiet by default
  } = opts

  // useAuth focuses on server state; actions like logout should use dedicated hooks

  const query = useQuery({
    queryKey: ['auth', 'me'],
    queryFn: async () => {
      try {
        const user = await apiService.auth.me()
        return user
      } catch (error) {
        // Handle 401 gracefully - user not authenticated
        if (error.response?.status === 401) {
          // Return null instead of throwing error
          return null
        }
        // Re-throw other errors
        throw error
      }
    },
    enabled,
    retry: false,
    staleTime: 5 * 60 * 1000,    // 5 minutes fresh
    gcTime: 60 * 60 * 1000,      // keep cache for 1 hour
    refetchOnMount: false,       // don't refetch just because a component mounts
    refetchOnWindowFocus,        // opt-in from the fetcher if you want
    // Suppress error logging for 401s since they're expected
    onError: (error) => {
      if (error.response?.status !== 401) {
        console.error('useAuth error:', error);
      }
    }
  })

  return {
    ...query,
    isAuthenticated: !!query.data,
  }
}
